import { merge } from '@fluentui/react';
import React, { useMemo } from 'react';
import { ResponsiveSize, useResponsiveSize } from '../contexts/responsiveContext';
import Banner from './Banner';

const BannerSmall = (props) => {

    const {
        categories = [],
        onChange = event => console.log(event),
        types = undefined
    } = props;

    const { responsiveSize } = useResponsiveSize();

    const styles = useMemo(
        () => {
            let styles = {
                outer: { root: { padding: 13 } },
                categories: {
                    inner: {
                        gap: 10,
                        width: 335
                    }
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        categories: {
                            inner: {
                                gap: 13,
                                width: 425
                            }
                        }
                    }
                );

            return styles;
        },
        [responsiveSize]
    );

    return <Banner
        {...props}
        categories={categories}
        customStyles={styles}
        onChange={onChange}
        types={types}
    />;

};

export default BannerSmall;